import { Component, ViewChild, ElementRef, AfterViewInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import SignaturePad from 'signature_pad';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';  // Assurez-vous d'importer FormsModule pour ngModel

@Component({
  selector: 'app-signature',
  standalone: true,
  imports: [CommonModule, MatButtonModule, FormsModule],
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss']
})
export class SignatureComponent implements AfterViewInit {
  @ViewChild('canvas') canvasEl!: ElementRef<HTMLCanvasElement>;
  signaturePad!: SignaturePad;
  private dialogRef = inject(MatDialogRef<SignatureComponent>);

  penSize: number = 3;  // Valeur par défaut pour la taille du stylo

  ngAfterViewInit() {
    console.log('ngAfterViewInit - Initialisation du pad');
    this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
    this.signaturePad.penColor = "#000000";  // Couleur initiale du stylo
    this.signaturePad.minWidth = this.penSize;  // Taille initiale du stylo
    this.signaturePad.maxWidth = this.penSize;  // Taille initiale du stylo
  }

  clear() {
    console.log('Action: clear signature pad');
    this.signaturePad.clear();
  }

  save() {
    console.log('Action: save signature');
    if (this.signaturePad.isEmpty()) {
      alert('Veuillez signer avant de continuer');
      console.warn('Tentative d’enregistrement sans signature');
      return;
    }
    const dataUrl = this.signaturePad.toDataURL();
    console.log('Signature capturée (base64) :', dataUrl);
    this.dialogRef.close(dataUrl); // Renvoie la signature au parent
  }

  // Fonction pour changer la couleur du stylo
  changeColor(event: any) {
    const color = event.target.value;
    this.signaturePad.penColor = color;
    console.log('Couleur du stylo changée :', color);
  }

  // Fonction pour changer la taille du stylo
  changeSize() {
    this.signaturePad.minWidth = this.penSize;
    this.signaturePad.maxWidth = this.penSize;
    console.log('Taille du stylo changée :', this.penSize);
  }
}
